module.exports = "/static/assets/610fb87d66b6749aeb96d475ceb62940.svg";